module.exports = __webpack_public_path__ + "img/img-ajude-voce-tambem.e27b0e13.png";